<div class="header overflow-hidden">
  <div class="z-20 w-full md:h-full lg:h-screen xl:h-screen header__bg__1 absolute"></div>
  <div class="z-10 w-full md:h-full lg:h-screen xl:h-screen header__bg__2 absolute"></div>
  <div class="w-full md:h-full lg:h-screen xl:h-screen header__bg__3 absolute"></div>
</div>
